import React from "react";
import { AlertType } from "features/shared/alerts/enums/alertType";
import Alert from "./Alert";

type Props = {
  alertInfo: string;
  renderButton?: () => JSX.Element;
  alertType?: AlertType;
};

const AlertWithButton = ({
  alertInfo,
  alertType = "Info",
  renderButton,
}: Props) => {
  return (
    <Alert alertObj={{ alertType: alertType }}>
      <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
        <span className="mr-sm-2 mb-1 mb-sm-0">{alertInfo}</span>
        {renderButton && <div>{renderButton()}</div>}
      </div>
    </Alert>
  );
};

export default AlertWithButton;
